import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {SpecialSearchModel} from "../special-search.model";
import {SpecialSearchPageComponent} from "../special-search-page/special-search-page.component";
import {SpecialEditPageComponent} from "../special-edit-page/special-edit-page.component";

@Component({
    selector: "wbo-special-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        provideSearchModel(SpecialSearchModel),
        registerSelectEditControl(SpecialSingleSelectEditControlComponent)
    ]
})
export class SpecialSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<SpecialSearchModel> {
    constructor(model: SpecialSearchModel, injector: Injector) {
        super(model, injector, "specialId", "name");

        this.extendedSearchComponent = SpecialSearchPageComponent;
        this.extendedEditComponent = SpecialEditPageComponent;
    }
}
